import { getInvoiceAssociatedObjectProperty, getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import ChargePaymentMethodPanel from 'commerce-shared-components-lib/features/tools/components/ChargePaymentMethodPanel';
import { CommerceTool } from 'commerce-shared-components-lib/common/constants/commerceTool';
// @ts-expect-error untyped customer-data-ui-utilities
import { addDanger } from 'customer-data-ui-utilities/alerts/Alerts';
import { jsx as _jsx } from "react/jsx-runtime";
export const OnFilePayStatus = {
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  PROCESSING: 'PROCESSING'
};
const InvoiceChargePaymentMethodPanel = props => {
  const {
    invoice,
    setIsChargePaymentMethodPanelOpen,
    resetChargePaymentMethodDisabledReason,
    onSuccess
  } = props;
  const invoiceContactObject = invoice.associatedObjects && invoice.associatedObjects.INVOICE_TO_CONTACT && invoice.associatedObjects.INVOICE_TO_CONTACT[0];
  const contact = {
    id: (invoiceContactObject === null || invoiceContactObject === void 0 ? void 0 : invoiceContactObject.objectId) && String(invoiceContactObject === null || invoiceContactObject === void 0 ? void 0 : invoiceContactObject.objectId) || '',
    firstname: getInvoiceAssociatedObjectProperty(invoiceContactObject, 'firstname') || undefined,
    lastname: getInvoiceAssociatedObjectProperty(invoiceContactObject, 'lastname') || undefined,
    email: getInvoiceAssociatedObjectProperty(invoiceContactObject, 'email') || ''
  };
  const amount = Number(getInvoiceProperty(invoice, 'hs_amount_billed') || 0);
  const sourceId = getInvoiceProperty(invoice, 'hs_number') || '';
  const crmId = String(invoice.objectId) || '';
  return /*#__PURE__*/_jsx(ChargePaymentMethodPanel, {
    currencyCode: getInvoiceProperty(invoice, 'hs_currency'),
    amount: amount,
    contact: contact,
    source: {
      sourceId,
      crmId,
      type: CommerceTool.INVOICES
    },
    onSuccess: onSuccess,
    onReject: () => {
      resetChargePaymentMethodDisabledReason();
      setIsChargePaymentMethodPanelOpen(false);
    },
    onFailure: () => {
      resetChargePaymentMethodDisabledReason();
      addDanger('invoices.alerts.chargePaymentMethod.danger');
      setIsChargePaymentMethodPanelOpen(false);
    }
  });
};
export default InvoiceChargePaymentMethodPanel;